"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#333",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "m15.015 13.86-.668-.874a.703.703 0 0 0-.985-.133l-.438.334c-.138.107-.353.014-.51-.08a3.4 3.4 0 0 1-.851-.826c-.546-.71-.764-1.365-.52-1.551l.437-.332a.7.7 0 0 0 .131-.982l-.667-.875a.7.7 0 0 0-.465-.269.7.7 0 0 0-.52.137l-.842.643c-.916.7-.542 2.367.974 4.35 1.155 1.509 2.306 2.331 3.195 2.331.272.004.537-.084.753-.249l.843-.642a.7.7 0 0 0 .133-.982"
  })]
}), 'Phone');
//# sourceMappingURL=index.js.map